import type { IconDefinition } from '../index.tsx';

export const iconInfoCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconInfoCircle',
  icon: [
    16,
    16,
    [],
    '',
    'M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7 8H6V6H9V11H10V13H7V8ZM9 5V3H7V5H9Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
